module.exports = __webpack_public_path__ + "img/06-Firebase.481c2898.png";